import { render, staticRenderFns } from "./PaginationControls.vue?vue&type=template&id=b3fd9c9c&scoped=true"
import script from "./PaginationControls.vue?vue&type=script&lang=js"
export * from "./PaginationControls.vue?vue&type=script&lang=js"
import style0 from "./PaginationControls.vue?vue&type=style&index=0&id=b3fd9c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fd9c9c",
  null
  
)

export default component.exports